export const footer = {
  Company: "Company",
  Product: "Product",
  Support: "Support",
  FDAPolicy:
    "*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.",
  FollowUs: "Follow us",
  FSAllRightsReserved: "Fullscript 2020. All Rights Reserved.",
  FDAStatements:
    "* These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.",
  GettingStarted: "Getting started",

  // aria labels and alt text
  CarbonZero: "Carbon Zero Certified. CZC-1482-1706-2020.",
  CarbonNeutral:
    "We’re certified carbon-neutral. It’s part of our commitment to helping people get better.",
  CopyrightAllRightsReserved: "© Fullscript 2022. All Right Reserved.",
} as const;
